// Because @types/jwplayer.QualityLevel and Level do not cover the recent change:
interface JWLevel extends jwplayer.Level {
    index: number
}

// Because @types/jwplayer.QualityLevel and Level do not cover the recent change:
export interface JWQualityLevel extends jwplayer.QualityLevel {
    level: JWLevel
}

interface IJWPBuckets {
    increment: number
    min: number
    max: number
}

interface IJWPBiddingSettings {
    mediationLayerAdServer: string
    sendAllBids?: boolean
    floorPriceCents?: number
    floorPriceCurrency?: string
    bidTimeout?: number
    buckets?: IJWPBuckets[]
}
interface IJWPBiddersProviders {
    delDomain?: string
    id?: string
    name: string
    platform?: string
    pubid: string
    siteId?: string
    zoneId?: string
}

interface IJWPPageTargeting {
    [key: string]: string
}

interface IJWPrules {
    startOnSeek: string
    timeBetweenAds: number
}
interface IJWPschedule {
    offset: string
    type?: string
    tag?: string
    custParams?: IJWPPageTargeting
}
export interface IJWPbids {
    bidOnBreaks?: number
    settings: IJWPBiddingSettings
    bidders: IJWPBiddersProviders[]
    ortbParams?: {
        plcmt: number
    }
}

export interface IJWPAdvertising {
    client: string
    adscheduleid: string
    schedule: IJWPschedule[] | string
    bids?: IJWPbids
    rules?: IJWPrules
    vpaidmode?: string

    // custom, not part of JW spec
    loc?: string
}

export interface IJWPlayerConfig {
    playlist: string | any
    advertising?: IJWPAdvertising
    width: string
    aspectratio: string
    controls: boolean
    autostart: string | boolean
    mute: boolean
    repeat: boolean
    mediaid: string
    logo?: {
        file: string
        link: string
        hide: boolean
        position: string
    }
}

export interface IJWMedia {
    title: string
    description: string
    kind: string
    playlist: Array<IJWPlaylist>
    feed_instance_id: string
}

export interface IJWPlaylist {
    title: string
    mediaid: string
    link: string
    image: string
    images: Array<IJWPlaylistImages>
    duration: number
    pubdate: number
    description: string
    tags: string
    sources: Array<IJWPlaylistSources>
    tracks: Array<IJWPlaylistTracks>
    variations: Record<string, unknown>
    monetize: string
    YouTubeStatus: string
    sensitive_video: string
    YoutubeId: string
}

export interface IJWPlaylistImages {
    src: string
    width: number
    type: string
}

export interface IJWPlaylistTracks {
    file: string
    kind: string
    label?: string
}

export interface IJWPlaylistSources {
    file: string
    type: string
    height?: number
    width?: number
    label?: string
    bitrate?: number
    filesize?: number
    framerate?: number
}

export interface IJWPSponsorshipAdTargeting {
    sensitive_video: string
    vid: string
    player?: string
    loc?: string
    permutive: string
}

export interface IJWPVideoAdTargeting {
    iu: string
    ppid: string
    plcmt: number
    description_url: string
    sz: string
    cmsid: string
    vid: string
    gdfp_req: string
    output: string
    unviewed_position_start: string
    env: string
    tfcd: string
    impl: string
    correlator: string
    cust_params: string
    ad_rule?: number
    vpos?: string
}

export interface IEmbedConfig {
    adsConfig?: {
        adTagParameters: {
            iu?: string
            cust_params?: string
            ppid?: string
            player?: string
        }
        nonPersonalizedAd?: boolean
    }
    relatedChannels?: Array<string>
    autonavRelatedVideos?: boolean
}

export type YTPlayerConfigEvent = YT.Events & {
    onAdEnd?: (event: YT.PlayerEvent) => void
    onRender?: () => void
    onPlay?: () => void
    onPause?: () => void
}
export type YTPlayerConfig = YT.PlayerOptions & {
    embedConfig?: IEmbedConfig
    events?: YTPlayerConfigEvent
}
export enum VideoProviderType {
    YouTube = 'youtube',
    JwPlayer = 'jwplayer',
    SendToNews = 'sendtonews',
    Connatix = 'connatix'
}

export enum VideoProviderShortType {
    YouTube = 'yt',
    JwPlayer = 'jw'
}

export enum VideoEventMap {
    JW_SKIP = 'JWskip'
}

export type JWPlayerConfigEvent = {
    onReady?: () => void
    onPlay?: (event: unknown) => void
    onPlaylistItem?: (event: jwplayer.PlaylistItemParam) => void
    onMute?: (event: jwplayer.MuteParam) => void
    onComplete?: () => void
    onPause?: () => void
    onError?: (event: jwplayer.ErrorParam) => void
    onAdPlay?: (event: jwplayer.AdPlayParam) => void
    onAdComplete?: () => void
    onAdSkipped?: () => void
    onSetupError?: () => void
    onVisualQuality?: (event: unknown) => void
    onRender?: () => void
}

export type IYTVideoAdTargetingConfig = {
    adUnit?: string
} & (
    | {
          adTargetingParams: string
          adTargetingParamsWithIas: string
      }
    | Record<any, never>
)
